import Header from "@/atomic/atoms/Header";
import { PropsView } from "./Models";

export default function RechargeView({
  goBack,
  goToCard,
  goToPix,
}: PropsView) {
  
  return (
    <div className="relative flex flex-1 flex-col w-full">
      <Header
        title="Pagamento"
        hasLeftButton
        goBack={goBack}
      />
      <main className="z-10 p-4 w-full flex justify-center h-full text-black h-form bg-white">
        <article className="h-full flex flex-col justify-between w-[calc(480px)]">
          <div>
            <h2 className="mt-6 text-black text-xl">Forma de pagamento</h2>
            <h3 className="text-black text-sm mt-2">Selecione abaixo como quer fazer o pagamento</h3>
            <button type="submit" onClick={goToCard} className="w-full flex justify-between items-center mt-5 text-start">
              <div className="flex items-center">
              <div className="bg-gray-100 rounded-lg p-4">
                <img 
                  src={"/svg/icon-payment-card.svg"}
                  className=" w-6 h-6"
                  alt="Card credit icon"
                />
                </div>
                <div className="ml-3">
                  <p className="text-base">Cartão de crédito</p>
                  <p className="text-xs">Informações do seu cartão</p>
                </div>
              </div>
              <img 
                src={"/svg/icon-arrow-right.svg"}
                width={10}
                height={10}
                alt="escolher cartão"
              />
            </button>
            <div className="w-full h-px bg-slate-300 mt-4 mb-4" />
            <button type="submit" onClick={goToPix} className="w-full flex justify-between items-center text-start">
              <div className="flex items-center">
                <div className="bg-gray-100 rounded-lg p-4">
                <img 
                  src={"/svg/icon-payment-pix.svg"}
                  alt="pix icon"
                  className="w-6 h-6"
                />
                </div>
                <div className="ml-3">
                  <p className="text-base">Pix</p>
                  <p className="text-xs">Informações para pagamento</p>
                </div>
              </div>
              <img 
                src={"/svg/icon-arrow-right.svg"}
                width={10}
                height={10}
                alt="escolher pix"
              />
            </button>
          </div>
        </article>
      </main>

    </div>
  );
}
